export default function updateEnrollData (state, payload) {
    return {
      ...state,
      enrollData: {
        ...state.enrollData,
        ...payload
      }
    }
  }
